import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';
import { RunnableLookupItemState } from './runnable-lookup-item-state';
import { RunnableLookupCell } from './runnableLookups-cell';

export class RunnableLookupSaveDataRow implements ViewModel {

  readonly friendlyTypeNameSingular = 'RunnableLookupSaveDataRow';
  readonly apiRoute: string = CONFIG.apiRoutes.RunnableLookupRows;

  lookupRowId: string;
  rowIndex: number;
  lookupCells: RunnableLookupCell[] = [];
  lookupId: string;

  state: RunnableLookupItemState = RunnableLookupItemState.Unchanged;

  json() {
    return this;
  }
  loadFromJson(data: any) {
    this.lookupRowId = data.lookupRowId;
    this.rowIndex = data.rowIndex;

    if (data.lookupCells) {
      data.lookupCells.forEach(cell => {
        const newCell = new RunnableLookupCell();
        newCell.loadFromJson(cell);
        this.lookupCells.push(cell);
      });
    }

    this.lookupId = data.lookupId;
  }
}

